<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!--procuration details  -->
    <div>
      <!-- title  -->
      <h2 class="mb-1" style="display: flex">
        {{ $t('Prokūros duomenys') }}
        <el-tooltip
          tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Prokūros duomenys"
          title
        ></el-tooltip>
      </h2>
      <v-card outlined>
        <!-- form  -->
        <v-card-text :class="showSelect ? '' : 'pa-0'">
          <v-row class="mb-0 pb-0">
            <!-- data list -->
            <v-col v-if="showDataList" class="pb-0" cols="12" md="12">
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr class="n-hov">
                      <td>
                        <strong>{{ $t('Dokumento tipas') }}: </strong>
                      </td>
                      <td>
                        {{ enumsClassifiers.inJournalType[$i18n.locale][formData.in_journal_type] }}
                      </td>
                    </tr>
                    <tr class="n-hov">
                      <td>
                        <strong>{{ $t('Prokūros rūšis') }}: </strong>
                      </td>
                      <td>
                        <el-autocomplete
                          required
                          :items="enumsClassifiers.procurationKind"
                          itemvalue="value"
                          itemtext="text"
                          enums
                          style="padding-top: 1.5rem"
                          v-model="formData.procuracy_type"
                          validateKey="type"
                          key="type"
                        />
                      </td>
                    </tr>
                    <tr v-if="showFormationDate" class="n-hov">
                      <td>
                        <strong>{{ $t('Sudarymo data') }}: </strong>
                      </td>
                      <td>
                        <el-date-picker
                          required
                          pastDates
                          style="padding-top: 1.5rem"
                          v-model="formData.formation_date"
                          validateKey="formation_date"
                          key="formation_date"
                        />
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <!-- select  -->
            <v-col v-if="showSelect" cols="12" md="12">
              <el-radio-group
                class="mt-0 mb-4"
                label="kind"
                v-model="kind"
                :items="kinds"
                @change="changeInJournalType()"
                required
              >
              </el-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>

    <!--Other procuration details  -->
    <div class="pt-4" v-if="showOtherProcurationDetails">
      <!-- title  -->
      <h3 class="mb-1" style="display: flex">
        {{ $t('Kiti prokūros duomenys')
        }}<el-tooltip
          tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Kiti prokūros duomenys"
          subTitle
        ></el-tooltip>
      </h3>
      <v-card class="mb-1" outlined>
        <!-- form  -->
        <v-card-text class="pb-0">
          <v-row class="mb-0 pb-0">
            <v-col class="pb-0 pt-2" cols="12" md="12">
              <strong>{{ $t('Prokūros suteikiamos teisės') }}</strong>
            </v-col>
            <v-col class="pb-0 pt-0" cols="12" md="12">
              <span>{{ getDetailsText }}</span>
            </v-col>
            <v-col class="pb-0 pt-2" cols="12" md="12">
              <el-checkbox
                class="mt-0 mb-4"
                style="width: fit-content"
                label="Prokūra ribota"
                tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Prokūra ribota"
                v-model="formData.procuracy_restricted"
                @change="procuracyRestrictedChanged"
              />
            </v-col>

            <v-col v-if="showLimitedText" class="pb-0" cols="12" md="12">
              <el-textarea
                :disabled="!limitedTextAvailable"
                :required="limitedTextRequired"
                label="Prokūros ribojimai"
                tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Prokūros ribojimai"
                v-model="formData.procuracy_restriction"
                :maxlength="2000"
              />
            </v-col>

            <v-col class="pb-0" cols="12" md="6">
              <el-date-picker
                :disabled="!temrDateAvailable"
                :required="termDateRequired"
                :pastDate="getPastDate"
                futureTermDates
                :today="this.today"
                label="Termino data"
                tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Termino data"
                v-model="formData.term_date"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="mt-4 mb-1" outlined>
        <v-card-text class="pb-0">
          <v-row class="mb-0 pb-0">
            <v-col v-if="isElSignatureAvailable" class="pb-1 pt-0" cols="12" md="12">
              <el-checkbox
                class="mt-0 mb-1"
                :disabled="false"
                label="Reikalingas pasirašymas kvalifikuotu el. parašu"
                tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas prokūra."
                v-model="formData.signature_required"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>

        <!--procuration documents  -->
    <div class="pt-4" v-if="showOtherProcurationDocuments">
      <!-- title  -->
      <h3 class="mb-1" style="display: flex">
        {{ $t('Dokumentai')
        }}<el-tooltip
          tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Dokumentai"
          subTitle
        ></el-tooltip>
      </h3>
      <v-card class="mb-1" outlined>
        <!-- form  -->
        <v-card-text class="pb-0">
          <!-- add button  -->
          <el-button
            small
            class="mb-3"
            color="primary"
            icon="pridėti"
            title="Įkelti dokumentą"
            :loading="loading"
            @click.native.stop="openNewDocument()"
          />
          <input id="fileUpload" type="file" @change="addFile($event)" hidden />
          <v-data-table
            class="mb-4 custom-table"
            :loading="loading"
            :headers="headers"
            :items="formData.documents"
            :hide-default-footer="true"
            :header-props="{
              sortByText: $t('Rūšiuoti pagal'),
            }"
          >
            <!-- custom templates -->
            <template #[`item.size`]="{ item }">
            <span>{{getItemSize(item)}}</span>
            </template>
            <!--  -->
            <template #[`item.actions`]="{ item }">
              <div class="nowrap">
                <el-table-action
                  :item="setDocumentsItem(item)"
                  @deleteItem="deleteItem(item)"
                  @downloadItem="download(item)"
                />
              </div>
            </template>
            <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
            <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
    <!-- actions  -->
    <v-card-actions>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <el-button
          v-if="!showBack"
          class="mr-1"
          color="secondary"
          title="Atgal"
          @click.native.stop="backInList()"
          :loading="loading"
        />
        <el-button
          v-if="showBack"
          class="mr-1"
          color="secondary"
          icon="atgal"
          title="Atgal"
          @click.native.stop="back()"
          :loading="loading"
        />
        <el-button
          v-if="!modeReadonly"
          title="Tęsti"
          :loading="loading"
          @click.native="next()"
          color="primary"
          icon="pirmyn"
        />
      </v-row>
    </v-card-actions>
       <!-- modals -->
    <modal-delete
      title="Šalinti dokumentą"
      :text="deleteText"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import userRole from '@/mixins/userRole'
import unsavedData from '@/mixins/unsavedData'
import Enums from '@/enums'
import math from '@/mixins/math'
import ModalDelete from '@/components/modals/ModalDelete'
import store from '@/store'
import { getFileSetting } from '@/services/classifierService.js'

export default {
  name: 'ProcurationStep1',
  components: { ModalDelete },
  mixins: [userRole, unsavedData, math],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      today: moment().format('YYYY-MM-DD HH:mm'),
      formData: {
        in_journal_type: '420',
        documents: [],
      },
      classifiers: {},
      enumsClassifiers: [],
      kind: null,
      documentsToDelete: [],
      showDelete: false,
      deleteText: 'Ar tikrai norite pašalinti dokumentą?',
      modalDeleteItem: null,
    }
  },
  computed: {
    ...mapGetters(['getUserCompany', 'getUserType', 'getIsPublic']),
    getPastDate() {
      return '9999-01-01'
    },
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Dokumento pavadinimas'),
          align: 'start',
          value: 'original_filename',
        },
        {
          text: this.$t('Dydis'),
          align: 'start',
          value: 'size',
        },
        {
          text: this.$t('Įkėlimo data'),
          align: 'start',
          value: 'created_at',
        },
      ]
    },
    getDetailsText() {
      return this.$t('atstovaujamojo vardu ir dėl jo interesų atlikti visus teisinius veiksmus, susijusius su juridinio asmens (verslininko) verslu, be to atstovaujamojo vardu ir dėl jo interesų atlikti teisinius veiksmus teisme ir kitose ne teismo institucijose (Lietuvos Respublikos civilinio kodekso 2.176 straipsnio 1 ir 2 dalys).')
    },
    kinds() {
      return [
        {
          label: this.$t('Elektroninis prokūros sudarymas'),
          value: 'ITPSP',
        },
        {
          label: this.$t('Prokūros dokumento ir duomenų teikimas'),
          value: 'PP',
        },
      ]
    },
    formatedTerms() {
      return this.enumsClassifiers.mandateTerms
    },
    getId() {
      return this.$route.params.id || null
    },
    modeReadonly() {
      return false
    },
    showBack() {
      return !this.getId && this.formData.kind && !store.getters.getUserCompany
    },
    showSelect() {
      return store.getters.getUserCompany ? !this.formData.kind : false
    },
    showDataList() {
      return this.formData.kind
    },
    showOtherProcurationDetails() {
      return this.formData.kind == 'ITPSP' || this.formData.kind == 'PP' || false
    },
    showOtherProcurationDocuments() {
      return this.kindPP
    },
    showFormationDate(){
      return this.kindPP
    },
    kindPP(){
      return this.formData.kind == 'PP' || false
    },
    temrDateAvailable() {
      return this.formData.procuracy_restricted
    },
    showLimitedText() {
      return !this.kindPP
    },
    limitedTextAvailable() {
      return this.formData.procuracy_restricted && this.formData.kind == 'ITPSP'
    },
    limitedTextRequired() {
      return this.formData.kind == 'ITPSP' && this.formData.procuracy_restricted && !this.formData.term_date
    },
    termDateRequired() {
      return (this.formData.kind == 'ITPSP' && this.formData.procuracy_restricted && !this.formData.procuracy_restriction)
        || (this.formData.kind == 'PP' && this.formData.procuracy_restricted)
    },
    isElSignatureAvailable() {
      return this.formData.kind == 'ITPSP'
    }
  },
  created() {
    this.getData()
  },
  mounted() {
    this.fileTypes = sessionStorage.getItem('file_types')
    this.maxSize = sessionStorage.getItem('max_file_size')
    if (!this.fileTypes){
      getFileSetting();
    }
  },
  watch: {},
  methods: {
    // deleteItem(item) {
    //   if(item.id){
    //     this.documentsToDelete.push(item.id)
    //   }
    //   const index = this.formData.documents.findIndex(
    //     (document) => document.upload_id === item.upload_id
    //   )
    //   if (index > -1) {
    //     this.formData.documents.splice(index, 1)
    //   }
    //   if (index == -1) {
    //     const subIndex = this.formData.documents.findIndex(
    //       (document) => document.create_id === item.create_id
    //     )
    //     if (subIndex > -1) {
    //       this.formData.documents.splice(subIndex, 1)
    //     }
    //   }
    // },
    deleteItem(item) {
      this.deleteText = this.$t(`Ar tikrai norite pašalinti dokumentą`) + ' ' + item.original_filename + `?`
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.showDelete = false
      if(item.id){
        this.documentsToDelete.push(item.id)
        this.formData.documentsToDelete = this.documentsToDelete
      }
      // uploaded
      if(item.id){
        const index = this.formData.documents.findIndex(
        (document) => document.id === item.id
        )
        if (index > -1) {
          this.formData.documents.splice(index, 1)
        }
      } else {
        const subIndex = this.formData.documents.findIndex(
          (document) => document.create_id === item.create_id
        )
        if (subIndex > -1) {
          this.formData.documents.splice(subIndex, 1)
        }
      }
    },
    procuracyRestrictedChanged() {
      if (!this.formData.procuracy_restricted) {
        this.formData.procuracy_restriction = null
        this.formData.term_date = null
      }
    },
    addFile(e) {
      let file = e.target.files[0]
      let obj = {
        canDelete: true,
        file: file,
        original_filename: file.name,
        size: this.bytesToSize(file.size),
        create_id: `${file.name}-${Date.now()}`,
      }

      if (
        typeof this.formData.documents === 'undefined' ||
        !Array.isArray(this.formData.documents)
      ) {
        this.$set(this.formData, 'documents', [])
      }
      this.formData.documents.push(obj)
      document.getElementById('fileUpload').value = ""
    },
    openNewDocument() {
      document.getElementById('fileUpload').click()
    },
    next() {
      if (this.showSelect) {
        if(this.getUserType === "JUR" && this.getIsPublic) {
          this.$root.$emit('DATA_ERROR_TEXT', 'Operacija negalima. Prokūrą gali išduoti tik verslą vykdantis juridinis asmuo.')
        } else {
          this.saveParameter()
        }
      } else {
        this.saveData()
      }
    },
    back() {
      this.formData = {}
      this.kind = 'ITPSP'
      this.$set(this.formData, 'in_journal_type', this.kind == 'ITPSP' ? '420' : '421')
      this.$set(this.formData, 'selectedItem', '')
    },
    backInList() {
      this.$router.push({
        name: 'savDocuments',
      })
    },
    getData() {
      this.kind = 'ITPSP'
      this.formData.in_journal_type = '420'
      this.enumsClassifiers = Enums
      if (!store.getters.getUserCompany) {
        this.saveParameter()
      }
      // edit
      if (this.getId) {
        this.pageloading = true
        this.$axios
          .get(`in-journals/${this.getId}`)
          .then((res) => {
            this.formData = res.data.inJournal
            if([803,804,807,808,810,811,812,813,815,816].includes(this.formData.status)){
              this.$router.push({ name: 'savDocuments' })
            }
          })
          .catch((err) => {
            this.$root.$emit('DATA_ERROR', err)
          })
          .finally(() => {
            this.pageloading = false
          })
      }
    },
    saveParameter() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.$set(this.formData, 'kind', this.kind)
        } else {
          this.$root.$emit('FORMAT_ERROR_STEP')
        }
      })
    },
    changeInJournalType() {
      this.$set(this.formData, 'in_journal_type', this.kind == 'ITPSP' ? '420' : '421')
    },
    saveData(toRoute) {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let totalFileSize = 0
          let formData = new FormData()
          let emitError;
          let fileTypes = sessionStorage.getItem('file_types')
          if (this.formData?.documents?.length > 0) {
            Object.keys(this.formData.documents).map((value, key) => {
              if (this.formData.documents[key].file !== undefined) {
                totalFileSize += this.formData.documents[key].file.size
                let filename = this.formData.documents[key].file.name
                let extension = filename.substr(filename.lastIndexOf('.') + 1)

                if (fileTypes.includes(extension.toLowerCase())) {
                  formData.append(
                    `documents[${key}]`,
                    this.formData.documents[key].file
                  )
                } else {
                  emitError = 'FILE_EXTENSION_NOT_ALLOWED';
                }
              }
            })
          }

          if (totalFileSize > sessionStorage.getItem('max_file_size')) {
            emitError = 'FILE_TOO_LARGE'
          }

          if (emitError === undefined) {
            formData.append('kind', this.formData.kind || '')
            formData.append('in_journal_type', this.formData.in_journal_type)
            formData.append('procuracy_type', this.formData.procuracy_type || '')
            formData.append('procuracy_restricted', this.formData.procuracy_restricted ? 1 : 0)
            formData.append('procuracy_restriction', this.formData.procuracy_restriction || '')
            formData.append('term', this.formData.term || '')
            formData.append('term_event', this.formData.term_event || '')
            formData.append('term_date', this.formData.term_date || '')
            formData.append('bilingual', this.formData.bilingual ? 1 : 0)
            formData.append('signature_required', this.formData.signature_required ? 1 : 0)
            if (this.kindPP) {
              formData.append('formation_date', this.formData.formation_date)
              formData.append('documentsToDelete', JSON.stringify(this.documentsToDelete))
            }
            let url = `in-journals/mandate-type`
            this.getId && formData.append('id', this.getId)
            this.$axios
              .post(url, formData)
              .then((res) => {
                this.$root.$emit('DATA_OK_STEP')
                this.initialForm()
                if (toRoute) {
                  this.goToRoute()
                } else {
                  this.$emit('gotoStep', {
                    step: '2',
                    id: res.data.inJournal.id,
                  })
                }
              })
              .catch((err) => {
                this.$root.$emit('DATA_ERROR', err)
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            this.$root.$emit(emitError)
            this.loading = false
          }
        } else {
          this.$root.$emit('FORMAT_ERROR_STEP')
        }
      })
    },
    download(item) {
      this.loading = true
      this.$axios
        .get(`uploads/${item.id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    setDocumentsItem(item){
      if(item.id){
        item.canDownload = true
        item.canDelete = true
      }
      return item
    },
    getItemSize(item){
      if(item.id){
        return this.bytesToSize(item.size)
      } else {
        return item.size
      }

    },
  },
}
</script>
<style lang="scss" scoped>
.n-hov {
  background-color: #f8f8f8 !important;
}
</style>
